/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/**
 * Google Analytics constants.
 * 
 * This is where we define event names and custom dimensions.
 * Note that custom dimensions must match the GA dimensions 
 * registered under "Custom definitions" in the GCP or Firebase Console. 
 * They are case-sensitive.
 */

// --------------------------------
// Event names
// --------------------------------
export const GA_EVENTS = {

    GA_TRACKING: 'ga_tracking',

    // Workflow events
    WORKFLOW_CLEAR: 'workflow_clear',
    WORKFLOW_LOAD: 'workflow_load',
    WORKFLOW_SAVE: 'workflow_save',
    WORKFLOW_RUN: 'workflow_run',
    WORKFLOW_STOP: 'workflow_stop',
    WORKFLOW_BLOCK_COMPLETE: 'workflow_block_complete',

    // Login/out events
    USER_LOGIN: 'user_login',
    USER_LOGOUT: 'user_logout',

    // Click events

    // Tabs and pages
    TAB_MAP: 'tab_map',
    TAB_DASHBOARD: 'tab_dashboard',
    TAB_DOWNLOADS: 'tab_downloads',
    TAB_ASSETS: 'tab_assets',
    PAGE_TUTORIALS: 'page_tutorials',


    // UI Buttons and Options
    BTN_FLIP_DISPLAY: 'btn_flip_display',
    BTN_MAP: 'btn_map',
    BTN_SATELLITE: 'btn_satellite',
    OPT_MAP_TERRAIN: 'opt_map_terrain',
    OPT_SATELLITE_LABEL: 'opt_satellite_label',

    BTN_ADD_AREA: 'btn_add_area',
    BTN_STOP_DRAWING: 'btn_stop_drawing',
    BTN_DRAW_SHAPE: 'btn_draw_shape',
    BTN_DRAW_RECT: 'btn_draw_rectangle',
    BTN_DELETE_POLYGON: 'btn_delete_polygon',
    BTN_ASSIGN_AREA: 'btn_assign_area',

    // Map buttons
    BTN_ZOOM_IN: 'btn_zoom_in',
    BTN_ZOOM_OUT: 'btn_zoom_out',
    BTN_FULL_SCREEN: 'btn_full_screen',
    BTN_SAVE_IMAGE: 'btn_save_image',

    BTN_EXAMPLE_WORKFLOWS_OPEN: 'btn_example_workflows_open',
    BTN_EXAMPLE_WORKFLOWS_CLOSE: 'btn_example_workflows_close',
    WORKFLOW_DETAIL_OPEN: 'workflow_open',
    WORKFLOW_DETAIL_CLOSE: 'workflow_close',
    LOAD_EXAMPLE_WORKFLOW: 'load_example_workflow',

    // Dialog show events
    DIALOG_LOAD_WORKFLOW: 'show_workflow_load',
    DIALOG_SAVE_WORKFLOW: 'show_workflow_save',
    DIALOG_UPLOAD_POLYGONS: 'show_upload_polygons',
    
    UPLOAD_POLYGONS_VECTOR_FILE: 'upload_polygons_vector_file',
    UPLOAD_POLYGONS_COORDS: 'upload_polygons_coords',

    // System interactions
    TANDC_AGREEMENT: 't_and_c_agreement',
    ANALYTICS_AGREEMENT: 'analytics_agreement',
    NET_PROMOTER_RESPONSE: 'np_response',
 };


// ---------------------------------
// Non-user initiated events
// ---------------------------------
export const GA_SYSTEM_EVENTS = {
    // Errors
    ERROR: 'error',

};

 
// ---------------------------------
// Event properties
// ---------------------------------
export const GA_EVENT_PROPS = {
    VALUE: "value",
    STATE: "state",
    NAME: "name",
    ORG_ID: "org_id",
    USER_ID: "user_id",
    ERR_CODE: "err_code",
    ERR_INFO: "err_msg",
};


// --------------------------------
// User properties
// --------------------------------
export const GA_USER_PROPS = {
    ORG_ID: "org_id",
    USER_ID: "user_id",
};
